const getClassNames = className => {
    return className.split(' ').filter(function(value, index, self) { 
        return self.indexOf(value) === index;
    }).join(' ');
}

module.exports = {
    getClassNames: getClassNames
};